import React, { useState } from "react";
import { useTranslation } from "react-i18next";
// this is used to add email
import addCredential from "api/auth/addCredential";
// this is used to add other credentials
// import addUserCredential from "api/clients/addCredential";
import controlUrlAvailable from "api/clients/controlUrlAvailable";
import { validateEmail } from "utilities/validateEmail";
import Icon from "@mui/material/Icon";
import Datetime from "react-datetime";
import IconButton from "@mui/material/IconButton";
import MDInput from "components/MDInput";
import SweetAlert from "react-bootstrap-sweetalert";
import Tooltip from "@mui/material/Tooltip";
import PrefixSelector from "./prefixSelector";
import PropTypes from "prop-types";
import moment from "moment";
import { number as validateCardNumber } from "card-validator";
import getCardSrc from "utilities/creditCards/getCardSrc";
import formatCardNumber from "utilities/creditCards/formatCardNumber";
import processCardNumber from "utilities/creditCards/processCardNumber";

function controlAddition(content, self) {
  return controlUrlAvailable(content, self)
    .then((res) => res)
    .catch((err) => {
      // eslint-disable-next-line
      console.log("error while checking availability", err);
    });
}

function AddCredential(props) {
  const [credential, setCredential] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phonePrefix, setPhonePrefix] = useState("");
  const [address, setAddress] = useState("");
  const [iban, setIban] = useState("");
  const [identifierNumber, setIdentifierNumber] = useState("");
  const [identifierType, setIdentifierType] = useState("");
  const [ccNumber, setCCNumber] = useState("");
  const [ccType, setCCType] = useState("");
  const [ccExpirationMonth, setCCExpirationMonth] = useState("");
  const [ccExpirationYear, setCCExpirationYear] = useState("");
  // eslint-disable-next-line
  const [isCardValid, setIsCardValid] = useState(false);
  const [errorInputEmail, setErrorInputEmail] = useState(false);
  const [emailUsed, setEmailUsed] = useState(false);
  // const [credentialUsed, setCredentialUsed] = useState(false);
  // const [errorInputCredential, setErrorInputCredential] = useState(false);
  // eslint-disable-next-line
  const [credentialType, setCredentialType] = useState("combolists");
  const { t } = useTranslation();

  function tryAddCredential() {
    const credentialToAdd = {
      client: props.clientForCredential,
      credential,
    };
    addCredential(credentialToAdd)
      .then((res) => {
        if (res && res.message) {
          props.successFunction();
        } else {
          props.errorFunction();
        }
      })
      .catch((err) => {
        // eslint-disable-next-line
        console.log("error while adding credential", err);
        props.errorFunction();
      });
  }

  function optionsYearsCC() {
    const options = [];
    for (let index = 2000; index < 2050; index++) {
      options.push(index);
    }
    return options.map((el) => (
      <option value={el} key={`year-option-${el.toString()}`}>
        {el}
      </option>
    ));
  }

  function getTypeInputs() {
    switch (credentialType) {
      case "combolists":
        return (
          <MDInput
            type={"input"}
            label={t("user.new_credential")}
            fullWidth
            value={credential}
            onChange={(e) => {
              if (errorInputEmail) {
                setErrorInputEmail(false);
              }
              if (emailUsed) {
                setEmailUsed(false);
              }
              setCredential(e.target.value);
            }}
          />
        );
      case "birthDates":
        return (
          <Datetime
            open
            className="add_credentials_birthDates"
            inputProps={{
              placeholder: t("user.credential_type_birthDates"),
              birthdate,
            }}
            closeOnSelect
            timeFormat={false}
            value={birthdate}
            onChange={(e) => {
              setBirthdate(moment(e).format("L"));
            }}
          />
        );
      case "addresses":
        return (
          <MDInput
            type={"input"}
            label={t("user.credential_type_addresses")}
            fullWidth
            value={address}
            onChange={(e) => {
              setAddress(e.target.value);
            }}
          />
        );
      case "ibans":
        return (
          <MDInput
            type={"input"}
            label={t("user.credential_type_ibans")}
            fullWidth
            value={iban}
            onChange={(e) => {
              setIban(e.target.value);
            }}
          />
        );
      case "phones":
        return (
          <div style={{ display: "flex", paddingBottom: "100px" }}>
            <PrefixSelector
              onSelect={(el) => {
                setPhonePrefix(el?.dial_code || "");
              }}
              defaultValue={phonePrefix}
              label={"prefix"}
            />
            <MDInput
              type={"input"}
              autoComplete={"off"}
              label={t("user.credential_type_phones")}
              fullWidth
              value={phoneNumber}
              onChange={(e) => {
                setPhoneNumber(e.target.value);
              }}
            />
          </div>
        );
      case "identifiers":
        return (
          <div>
            <select
              value={identifierType}
              style={{
                border: "none",
                borderBottom: "solid 1px rgba(52, 71, 103, 0.3)",
                padding: "5px 10px",
                outline: "none",
                fontSize: "14px",
                marginBottom: "20px",
              }}
              onChange={(e) => {
                setIdentifierType(e.target.value);
              }}
            >
              <option value="id">{t("user.id")}</option>
              <option value="passport">{t("user.passport")}</option>
              <option value="cf">{t("user.cf")}</option>
              <option value="driving_license">{t("user.driving_license")}</option>
              <option value="ssn">{t("user.ssn")}</option>
            </select>
            <MDInput
              type={"input"}
              label={t("user.identifier_number")}
              fullWidth
              value={identifierNumber}
              onChange={(e) => {
                setIdentifierNumber(e.target.value);
              }}
            />
          </div>
        );
      case "userCreditCards":
        return (
          <div>
            <MDInput
              type={"input"}
              label={t("user.credit_card_number")}
              fullWidth
              style={{ marginBottom: "20px" }}
              value={ccNumber}
              onChange={(e) => {
                const formattedValue = formatCardNumber(e.target.value);
                setCCNumber(formattedValue);
                const validation = validateCardNumber(e.target.value);
                console.log("validation", validation);
                setIsCardValid(validation.isValid);
                setCCType(validation.card?.type || null);
              }}
            />
            <div style={{ marginBottom: "20px", display: "flex", alignItems: "center" }}>
              <span style={{ fontSize: "16px", marginRight: "10px" }}>
                {t("user.credit_card_type")}:
              </span>
              <img
                src={getCardSrc(ccType)}
                style={{ width: "30px", height: "auto", marginRight: "5px" }}
                alt="card type"
              />
            </div>
            <div>
              <span style={{ fontSize: "16px" }}>{t("user.credit_card_expiration")}:</span>
              <select
                value={ccExpirationMonth}
                style={{
                  border: "none",
                  padding: "5px 10px",
                  outline: "none",
                  fontSize: "14px",
                  marginBottom: "20px",
                }}
                onChange={(e) => {
                  setCCExpirationMonth(e.target.value);
                }}
              >
                <option value="1">01</option>
                <option value="2">02</option>
                <option value="3">03</option>
                <option value="4">04</option>
                <option value="5">05</option>
                <option value="6">06</option>
                <option value="7">07</option>
                <option value="8">08</option>
                <option value="9">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </select>
              {" / "}
              <select
                value={ccExpirationYear}
                style={{
                  border: "none",
                  padding: "5px 10px",
                  outline: "none",
                  fontSize: "14px",
                  marginBottom: "20px",
                }}
                onChange={(e) => {
                  setCCExpirationYear(e.target.value);
                }}
              >
                {optionsYearsCC()}
              </select>
            </div>
          </div>
        );
      default:
        return (
          <MDInput
            type={"input"}
            label={t("user.new_credential")}
            fullWidth
            value={credential}
            onChange={(e) => {
              if (errorInputEmail) {
                setErrorInputEmail(false);
              }
              if (emailUsed) {
                setEmailUsed(false);
              }
              setCredential(e.target.value);
            }}
          />
        );
    }
  }

  function getTypeForControl(type) {
    switch (type) {
      case "combolists":
        return "combos";
      case "birthDates":
        return "birthDates";
      case "addresses":
        return "addresses";
      case "phones":
        return "phones";
      case "ibans":
        return "ibans";
      case "userCreditCards":
        return "userCreditCards";
      case "identifiers":
        return "identifiers";
      default:
        return "combos";
    }
  }

  function getContentForControl(type) {
    switch (type) {
      case "combolists":
        if (credential && validateEmail(credential)) {
          return credential;
        }
        return null;
      case "birthDates":
        if (birthdate && moment(birthdate).isBefore(moment())) {
          return { birthDate: birthdate };
        }
        return null;
      case "addresses":
        if (address) {
          return { address };
        }
        return null;
      case "phones":
        if (phonePrefix && phoneNumber) {
          return { number: phoneNumber, prefix: phonePrefix };
        }
        return null;
      case "ibans":
        if (iban) {
          return { iban };
        }
        return null;
      case "userCreditCards":
        if (ccNumber && ccExpirationMonth && ccExpirationYear && ccType) {
          const { hashNumber, blurryNumber } = processCardNumber(ccNumber);
          const expiration = moment(`${ccExpirationMonth}/1/${ccExpirationYear}`)
            .endOf("month")
            .subtract(1, "days");
          return { hashNumber, blurryNumber, type: ccType, expiration };
        }
        return null;
      case "identifiers":
        if (identifierType && identifierNumber) {
          return { value: identifierNumber, type: identifierType };
        }
        return null;
      default:
        return "combos";
    }
  }

  return (
    <div>
      <SweetAlert
        style={{ display: "block", position: "relative", textAlign: "left" }}
        title={t("user.add_credential")}
        onConfirm={() => {
          if (
            (credential && validateEmail(credential)) ||
            iban ||
            address ||
            birthdate ||
            (phoneNumber && phonePrefix) ||
            (identifierNumber && identifierType) ||
            (ccNumber && ccType && ccExpirationMonth && ccExpirationYear)
          ) {
            // TODO controllare che la mail non sia già stata presa, altrimenti errore
            // we can send everything, backend will skip check if not necessary (like birthDate)
            // content => credential should be build according to user selection
            controlAddition({
              type: getTypeForControl(credentialType),
              content: getContentForControl(credentialType),
            }).then((res) => {
              if (res) {
                tryAddCredential();
              } else {
                setEmailUsed(true);
              }
            });
          } else {
            setErrorInputEmail(true);
          }
        }}
        onCancel={() => {
          props.closeFunction();
        }}
        closeOnClickOutside
        showCancel
        cancelBtnText={t("cancel")}
        confirmBtnText={t("save")}
        confirmBtnCssClass="popupCloseButton"
        confirmBtnStyle={{
          boxShadow: "none",
        }}
        cancelBtnCssClass="popupCloseButton"
        cancelBtnStyle={{
          boxShadow: "none",
        }}
      >
        <div style={{ textAlign: "left" }}>
          <div style={{ textAlign: "left" }}>
            {/* <div style={{ marginBottom: "20px", position: "relative" }}>
              <select
                value={credentialType}
                style={{
                  border: "none",
                  borderBottom: "solid 1px rgba(52, 71, 103, 0.3)",
                  padding: "5px 10px",
                  outline: "none",
                  fontSize: "14px",
                }}
                onChange={(e) => {
                  setCredentialType(e.target.value);
                }}
              >
                {props.availableOptions.includes("combolists") ? (
                  <option value="combolists">{t("user.credential_type_combolists")}</option>
                ) : null}
                {props.availableOptions.includes("birthDates") ? (
                  <option value="birthDates">{t("user.credential_type_birthDates")}</option>
                ) : null}
                {props.availableOptions.includes("phones") ? (
                  <option value="phones">{t("user.credential_type_phones")}</option>
                ) : null}
                {props.availableOptions.includes("addresses") ? (
                  <option value="addresses">{t("user.credential_type_addresses")}</option>
                ) : null}
                {props.availableOptions.includes("ibans") ? (
                  <option value="ibans">{t("user.credential_type_ibans")}</option>
                ) : null}
                {props.availableOptions.includes("userCreditCards") ? (
                  <option value="userCreditCards">
                    {t("user.credential_type_userCreditCards")}
                  </option>
                ) : null}
                {props.availableOptions.includes("identifiers") ? (
                  <option value="identifiers">{t("user.credential_type_identifiers")}</option>
                ) : null}
              </select>
            </div> */}
            <div style={{ marginBottom: "20px", position: "relative" }}>
              {getTypeInputs()}
              {errorInputEmail ? (
                <div style={{ color: "var(--red-color)", fontSize: "16px" }}>
                  {t("user.wrong_email")}
                </div>
              ) : null}
              {emailUsed ? (
                <div style={{ color: "var(--red-color)", fontSize: "16px" }}>
                  {t("user.email_already_used")}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div className="popupButtonEdit">
          <Tooltip title={t("close")} placement="top">
            <IconButton
              onClick={() => {
                props.closeFunction();
              }}
              size="small"
              disableRipple
            >
              <Icon fontSize="medium">close</Icon>
            </IconButton>
          </Tooltip>
        </div>
      </SweetAlert>
    </div>
  );
}

AddCredential.propTypes = {
  clientForCredential: PropTypes.string,
  errorFunction: PropTypes.func,
  successFunction: PropTypes.func,
  closeFunction: PropTypes.func,
  availableOptions: PropTypes.array,
};

AddCredential.defaultProps = {
  clientForCredential: "",
  errorFunction: () => {},
  successFunction: () => {},
  closeFunction: () => {},
  availableOptions: [],
};

export default AddCredential;
